import { render, staticRenderFns } from "./StartGame.vue?vue&type=template&id=38844cc0&scoped=true&"
import script from "./StartGame.vue?vue&type=script&lang=js&"
export * from "./StartGame.vue?vue&type=script&lang=js&"
import style0 from "./StartGame.vue?vue&type=style&index=0&id=38844cc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38844cc0",
  null
  
)

export default component.exports